export default {
    'diagram2-3a2': {
        'diagram-task': 'Fill in the rough summary and the simplified summary',

        'fixed-answer1': 'Don’t knock paying taxes',
        'fixed-answer2': 'Not paying proper taxes dooms state support for future radical innovations',
        'pre-fill': 'Not paying proper taxes',

        'fixed-answer3': 'Most <u>radical innovations need</u> early-stage, <u>high-risk investment</u>',
        'fixed-answer4': 'The <u>State has been the early investor</u> in most of the recent big winners',
        'fixed-answer5': 'Big winners who don’t pay proper taxes threaten future State investment',
        'fixed-answer6': '- iPhone<br>- Internet<br>- GPS<br>- Touchscreen<br>- Siri',
    }
};



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a2/diagram2/i18n/en.js